export const ALLOWED_TO_WITHDRAW_PATH = '/allowed-to-withdraw'
export const KILL_SWITCH_PATH = '/withdrawls-disabled'
